export enum SalesOpportunityTedency {
  DEFAULT = 'DEFAULT',
  UP = 'UP',
  DOWN = 'DOWN',
}
